<template>
  <div class="cr-summary">
    <div class="cr-summary-item cr-summary-scope">
      <small>Período</small>
      <div class="cr-summary-value">{{ periodText }}</div>
      <span class="cr-summary-hint">{{ planName }}</span>
    </div>

    <div class="cr-summary-item highlight clickable"
         :class="{zero: !summary.open.count, 'is-on': active === 'none'}"
         @click="$emit('filter', 'none')">
      <small>A faturar</small>
      <div class="cr-summary-value">
        <span class="gd-sk" v-if="loading"></span>
        <template v-else>{{ summary.open.total | currency }}</template>
      </div>
      <span class="cr-summary-hint">
        <span class="gd-sk" v-if="loading"></span>
        <template v-else>{{ openHint }}</template>
      </span>
    </div>

    <div class="cr-summary-item soft clickable"
         :class="{zero: !summary.inBatch.count, 'is-on': active === 'with'}"
         @click="$emit('filter', 'with')">
      <small>Em lote</small>
      <div class="cr-summary-value">
        <span class="gd-sk" v-if="loading"></span>
        <template v-else>{{ summary.inBatch.total | currency }}</template>
      </div>
      <span class="cr-summary-hint">
        <span class="gd-sk" v-if="loading"></span>
        <template v-else>{{ inBatchHint }}</template>
      </span>
    </div>

    <div class="cr-summary-item soft done clickable"
         :class="{zero: !summary.closed.count, 'is-on': active === 'closed'}"
         @click="$emit('filter', 'closed')">
      <small>Encerradas</small>
      <div class="cr-summary-value">
        <span class="gd-sk" v-if="loading"></span>
        <template v-else>{{ summary.closed.total | currency }}</template>
      </div>
      <span class="cr-summary-hint">
        <span class="gd-sk" v-if="loading"></span>
        <template v-else>{{ closedHint }}</template>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    summary: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    periodText: {
      type: String,
      default: '',
    },
    planName: {
      type: String,
      default: '',
    },
    active: {
      type: String,
      default: null,
    },
  },
  computed: {
    openHint() {
      const count = this.summary.open.count || 0;
      if (count === 0) return 'nenhuma guia sem lote';
      return `${count} ${count === 1 ? 'guia sem lote' : 'guias sem lote'}`;
    },
    inBatchHint() {
      return this.guidesLabel(this.summary.inBatch.count || 0);
    },
    closedHint() {
      return this.guidesLabel(this.summary.closed.count || 0);
    },
  },
  methods: {
    guidesLabel(count) {
      if (count === 0) return 'nenhuma guia';
      return `${count} ${count === 1 ? 'guia' : 'guias'}`;
    },
  },
};
</script>
